import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-infobar-item',
  template: `<div *ngIf="!hidden" class="flex items-center">
    <div class="mr-8 flex flex-nowrap items-center" [pTooltip]="getTooltip()" tooltipPosition="top" [escape]="false">
      <span *ngIf="prefix" class="mr-1"
        ><b>{{ prefix }}</b></span
      >
      <span *ngIf="icon" class="mr-1"><i [class]="icon" class="text-gray-600"></i></span>
      <div [ngClass]="className">{{ value }}</div>
      <p-badge
        *ngIf="counter && counter !== '0'"
        [value]="'+' + counter"
        styleClass="ml-1 p-badge-xs p-badge-secondary"></p-badge>
    </div>
  </div>`,
  standalone: false
})
export class InfoBarItemComponent {
  @Input() index: number;
  @Input() icon: string;
  @Input() value: string;
  @Input() tooltips: string[];
  @Input() counter: string;
  @Input() prefix: string;
  @Input() className: string;
  @Input() hidden: boolean;

  getTooltip() {
    if (this.tooltips == null || this.tooltips.length === 0) return null;

    return this.tooltips.reduce((tooltip, nextLine) => (tooltip += '<p>' + nextLine + '</p>'), '');
  }
}
